import { P2GBox, P2GProgress, P2GFade } from '@parcel2go/core-ui';
const Loading = ({ p }: { p?: number }) => (
  <P2GBox textAlign="center" p={p !== undefined ? p : 4}>
    <P2GFade in>
      <P2GProgress size="large" variant="primary" />
    </P2GFade>
  </P2GBox>
);

export default Loading;
